import { createSelector } from "reselect";
import { NodeRepeatNotificationExpand, RepeatNotificationData } from ".";
import { NodeType } from "../organization";
import {
  nodeById,
  organizationNodes,
  pathToNode,
  userAssessNode,
} from "../organization/selectors";
import { IAppState, SortDirection } from "../types";
import { authReady, profileReady } from "../userProfile/selectors";
import { RoleType } from "../users";

export const repeatAlertReady = createSelector(
  profileReady,
  userAssessNode,
  (state: IAppState) => state.organization.rootOrganization.id,
  (state: IAppState): boolean => state.repeatAlert.isLoading,
  (mainLoaded, userNode, rootNodeId, isLoading) => {
    return !mainLoaded ? false : isLoading !== undefined && isLoading === false;
  }
);

export const shouldDisplayNotificationPage = createSelector(
  authReady,
  userAssessNode,
  (state: IAppState) => state.userProfile.roleName,
  (mainLoaded, userNode, roleName) => {
    if (!mainLoaded) return false;
    if (
      [RoleType.DISPLAY, RoleType.VIEWER, RoleType.CAREGIVER].indexOf(
        roleName
      ) !== -1
    )
      return false;
    if (userNode?.type === NodeType.Root) return true;

    return false;
  }
);

export const groupRepeatSettings = createSelector(
  authReady,
  (state: IAppState): RepeatNotificationData => state.repeatAlert.nodeDataNew,

  (_: IAppState, groupId: number): number => groupId,
  (mainLoaded, nodeDataNew, groupId) => {
    if (!mainLoaded) return undefined;
    if (!nodeDataNew) return undefined;
    return nodeDataNew[groupId];
  }
);

export const groupsNotificationsToDisplay = createSelector(
  (state: IAppState): RepeatNotificationData => state.repeatAlert.nodeDataNew,
  (state: IAppState): string => state.repeatAlert.settings.searchValue,
  (state: IAppState): SortDirection => state.repeatAlert.settings.sort,
  organizationNodes,
  (nodeDataNew, searchValue, sort, organizationNodes) => {
    if (!nodeDataNew) return [];
    const filterBySearch = (departmentId: string): boolean => {
      if (searchValue === "") return true;
      const node = nodeById(organizationNodes, Number.parseInt(departmentId));
      const path = pathToNode(
        organizationNodes,
        Number.parseInt(departmentId),
        false
      );
      return (
        node.title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
        path.some(
          (el) =>
            el.title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
        )
      );
    };
    const sortCondition = (aF: string, bF: string): number => {
      const a = nodeById(organizationNodes, Number.parseInt(aF));
      const b = nodeById(organizationNodes, Number.parseInt(bF));
      if (a.title.toLowerCase() < b.title.toLowerCase()) {
        return sort === SortDirection.ASC ? -1 : 1;
      }

      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return sort === SortDirection.ASC ? 1 : -1;
      }
      return 0;
    };
    const res: NodeRepeatNotificationExpand[] = [];
    const filtered = Object.keys(nodeDataNew)
      .filter(filterBySearch)
      .sort(sortCondition);
    filtered.map((onekey: string) =>
      res.push({
        ...nodeDataNew[Number.parseInt(onekey)],
        nodeId: Number.parseInt(onekey),
      })
    );
    return res;
  }
);

export const audioNotificationGroupsSelectedCreator = () => {
  return createSelector(
    (state: IAppState): number[] => state.repeatAlert.settings.selectedNodeIds,
    (_: IAppState, groupId: number): number => groupId,
    (selectedNodeIds, groupId) => {
      return selectedNodeIds.indexOf(groupId) !== -1;
    }
  );
};

export const isSelectionMode = createSelector(
  (state: IAppState): number[] => state.repeatAlert.settings.selectedNodeIds,
  (selectedNodeIds) => {
    return selectedNodeIds.length > 0;
  }
);
